/**
 * Api handlers for the App.
 * These will expose functions using the endpoints to call itslearning api's
 */
import { searchCourses as searchCoursesExternal } from './externalCatalogueApi';
import { searchCourses as searchCoursesInternal } from './localCatalogueApi';

export interface Paging {
  pageIndex: number;
  pageSize: number;
}

export interface CatalogueFilterModel {
  paging: Paging;
  searchText: string;
  targetRole: string;
  subjectId: string;
  educationalLevelId: string;
  organisationId: string;
}

export interface AntiForgery {
  antiForgeryHeaderName: string;
  antiForgeryHeaderValue: string;
}

export interface CatalogueCoursesModel {
  currentFilter: CatalogueFilterModel;
  totalCount: number;
  courses: CatalogueCourseModel[];
}

export interface CatalogueCourseTeacherModel {
  fullName: string;
  personId: number;
  personPictureUrl: string;
  isContactPersonInCatalogue: boolean;
}

export interface CatalogueCourseModel {
  courseId: number;
  title: string;
  content: string;
  subject: string;
  educationalLevel: string;
  imageUrl: string;
  targetRoles: string[];
  subjectId: string;
  teachers: CatalogueCourseTeacherModel[];
  courseUrl: string;
  isUserEnrolled: boolean;
}

export interface FilterOption {
  id: string;
  name: string;
}

/**
 * Creates a search function configured for either external or internal catalogue
 * @param isExternal Whether course catalogue is for external courses
 */
export const createSearchCourses = (isExternal:boolean) => {
    const searchCoursesApi = isExternal 
        ? searchCoursesExternal : searchCoursesInternal;
    
    return (data: CatalogueFilterModel,
            antiForgery: AntiForgery,
            signal: AbortSignal): Promise<CatalogueCoursesModel> => searchCoursesApi(data, antiForgery, signal);
};
